import { render, staticRenderFns } from "./SaveArchive.vue?vue&type=template&id=c0bb958c&scoped=true&"
import script from "./SaveArchive.vue?vue&type=script&lang=js&"
export * from "./SaveArchive.vue?vue&type=script&lang=js&"
import style0 from "./SaveArchive.vue?vue&type=style&index=0&id=c0bb958c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0bb958c",
  null
  
)

export default component.exports